// extracted by mini-css-extract-plugin
module.exports = {"block":"inputSetValue_block_1p9AB","icon":"inputSetValue_icon_-T96J"};